import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import Tab from "components/Tab";
import MaskingInputWeb from "./autocapture-config-web.mdx";
import MaskingInputIos from "./autocapture-config-ios.mdx";
import MaskingInputReactNative from "./autocapture-config-react-native.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`PostHog will make a best effort to not capture sensitive information by default. This is not always sufficient, so you can disable autocapture for specific elements.`}</p>

    <Tab.Group tabs={['Web', 'iOS', 'React Native']}>
    <Tab.List>
        <Tab mdxType="Tab">Web</Tab>
        <Tab mdxType="Tab">iOS</Tab>
        <Tab mdxType="Tab">React Native</Tab>
    </Tab.List>
    <Tab.Panels>
        <Tab.Panel>
            <MaskingInputWeb mdxType="MaskingInputWeb" />
        </Tab.Panel>
        <Tab.Panel>
            <MaskingInputIos mdxType="MaskingInputIos" />
        </Tab.Panel>
        <Tab.Panel>
            <MaskingInputReactNative mdxType="MaskingInputReactNative" />
        </Tab.Panel>
    </Tab.Panels>
    </Tab.Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      